const STORAGE_KEY = 'procurify.ap-po-export.promo-dismissed.v1'

interface Dependency {
  // A getter, not the Storage itself: reading `window.sessionStorage` throws a
  // SecurityError when the browser blocks site data, so it must only happen
  // inside the try blocks below, never at module load.
  getStorage: () => Storage
}

export class ApPoExportPromoDismissalRepository {
  constructor(private readonly deps: Dependency) {}

  isDismissed(): boolean {
    try {
      return this.deps.getStorage().getItem(STORAGE_KEY) === 'true'
    } catch {
      return false
    }
  }

  dismiss(): void {
    try {
      this.deps.getStorage().setItem(STORAGE_KEY, 'true')
    } catch {
      // The model hook still hides the promo for this mount; it just won't
      // stay dismissed across a reload.
    }
  }
}
